export default __webpack_public_path__ + "static/media/generic-device.d36eb12e.svg";